export const baseApiEndpoint =
  import.meta.env.VITE_APP_BASE_URL ||
  'https://api-dev.fafu.com.vn/fdl-service/api';
